'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _imagePath = require('@/mixins/image-path');

var _imagePath2 = _interopRequireDefault(_imagePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_imagePath2.default],
  props: ['item', 'index'],
  data: function data() {
    return {
      showCas: false,
      levelMenuData: [],
      imgsrc: ''
    };
  },

  watch: {
    item: function item() {
      this.getImgSrc('imgsrc', 'course', this.item.iconImg, 'open');
    }
  },
  mounted: function mounted() {
    this.getImgSrc('imgsrc', 'course', this.item.iconImg, 'open');
  },

  inject: ['selectLi', 'hideMenu', 'addClassName'],
  methods: {
    //一级菜单点击事件
    addClass: function addClass(item, parentData) {
      this.addClassName(item, parentData);
    },

    //展示二、三级菜单
    showSubmenu: function showSubmenu(item, parentData) {
      this.selectLi(item, parentData);
    },

    //隐藏二、三级菜单
    hideSubmenu: function hideSubmenu() {
      this.hideMenu();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//